export const transactionPreviewParams: Record<string, any> = {
	include:
		"infos,payment_method,sub_transactions,contexts,contexts.context_id,contexts.tax_items,external_id_inconsistency,refundable",
};
